export default "__VITE_ASSET__D3M5rodc__"